import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { osmDelete, osmGet, osmPost } from '@/api/osmClient';
import type { Geofence } from '@/types/osm';

const KEY = ['osm', 'geofences'] as const;

export function useOsmGeofences() {
  return useQuery<Geofence[]>({
    queryKey: KEY,
    queryFn: () => osmGet<Geofence[]>('/geofences'),
    staleTime: 30_000,
  });
}

interface CreateInput {
  name: string;
  kind: string;
  description?: string;
  geometry: Geofence['geometry'];
}

export function useCreateOsmGeofence() {
  const qc = useQueryClient();
  return useMutation<Geofence, Error, CreateInput>({
    mutationFn: (body) => osmPost<Geofence, CreateInput>('/geofences', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteOsmGeofence() {
  const qc = useQueryClient();
  return useMutation<void, Error, number>({
    mutationFn: (id) => osmDelete(`/geofences/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
